module.exports = __webpack_public_path__ + "ae2a45f8a2490b76016e88ff8100cc0c.jpg";